import { useState, useEffect } from "react";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

import { NavLink } from "react-router-dom";

import "./About.css";
import "../Home/Components/attributes/Attributes.css"

import Navbar from "../Navbar/Navbar";
import Footer from "../Home/Components/footer/Footer";
import FAQ from "../FAQ/FAQ";

// Images
import StoryImg from "../../2023-11-01.webp";
import UserIcon from "./images/userIcon.webp";

import Female from "./images/4.png";
import Male from "./images/3.png";

const About = () => {
    const [imgIndex, setImgIndex] = useState(0);
    const [selectedMember, setSelectedMember] = useState(null);
    const [slidesToShow, setSlidesToShow] = useState(4);

    const storyImages = [StoryImg, StoryImg, StoryImg, StoryImg, StoryImg];

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width <= 768) {
                setSlidesToShow(1);
            } else if (width <= 960) {
                setSlidesToShow(2);
            } else if (width <= 1200) {
                setSlidesToShow(3);
            } else {
                setSlidesToShow(4);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setImgIndex((prev) => (prev + 1) % storyImages.length);
        }, 4000);
        return () => clearInterval(interval);
    }, [storyImages.length]);

    const guides = [
        {
            name: "Ms Varsha Sharma",
            role: "Founder Director (Montessori Directress)",
            quote: "Nurturing the child's natural spirit of exploration and independence.",
            education: "Specialized in Early Childhood Education and Montessori training.",
            journey: "Over 12+ years of experience leading Montessori houses of children, designing child-centered environments where self-discipline flourishes.",
            expertise: "Environmental design, child observations, parent counseling, and child-led sensory learning.",
            philosophy: "Our duty is to prepare the environment so the child can grow freely and discover their potential.",
            email: "varsha@anubhavamontessori.com",
            image: UserIcon
        },
        {
            name: "Ms Syeda Khudsia Quadri",
            role: "Principal (Montessori Directress)",
            quote: "Education is not what the teacher gives, but is a natural process.",
            education: "Post-graduate in Education and certified Montessori practitioner.",
            journey: "Led curriculum design and school operations for over a decade, facilitating developmental milestones across primary stages.",
            expertise: "Child psychology, curriculum integration, language acquisition, and social emotional development.",
            philosophy: "Let us help the child to act, to think, and to choose for themselves.",
            email: "khudsia@anubhavamontessori.com",
            image: UserIcon
        },
        {
            name: "Ms Alisha Rupani",
            role: "Montessori Directress",
            quote: "Guiding young minds with care, patience, and love.",
            education: "Certified Montessori Guide and Child Development specialist.",
            journey: "Specialized in Montessori toddler and primary education, designing interactive math and language programs.",
            expertise: "Hands-on sensory learning, early literacy development, and behavioral guidance.",
            philosophy: "Every child is unique and has their own timeline for growth.",
            email: "alisha@anubhavamontessori.com",
            image: UserIcon
        },
        {
            name: "Ms Amina Gilani",
            role: "Assistant Directress",
            quote: "Fostering curiosity through daily classroom assistance.",
            education: "Trained in Montessori classroom management and assistant directorship.",
            journey: "5+ years of assisting guides in managing classroom dynamics and organizing materials.",
            expertise: "Creative arts, material presentation, and child monitoring.",
            philosophy: "Every small step in a child's learning journey counts.",
            email: "amina@anubhavamontessori.com",
            image: UserIcon
        },
        {
            name: "Ms Simran Dodhiya",
            role: "Assistant Directress",
            quote: "Creating a welcoming environment for kids to feel safe and happy.",
            education: "Childcare education diploma.",
            journey: "Actively supporting primary and preschool children in daily practical life tasks and outdoor play.",
            expertise: "Practical life guidance, storytelling, and play-based activities.",
            philosophy: "A happy child is a learning child.",
            email: "simran@anubhavamontessori.com",
            image: UserIcon
        },
        {
            name: "Ms Jyothi Pendiyal",
            role: "Learning Facilitator, Telugu",
            quote: "Empowering children to connect with their regional roots.",
            education: "Bachelor of Education in languages.",
            journey: "Designing bilingual communication materials and activities to improve language retention.",
            expertise: "Bilingual training, cultural arts, and dramatic storytelling.",
            philosophy: "Language is the key to heritage and understanding.",
            email: "jyothi@anubhavamontessori.com",
            image: UserIcon
        }
    ];


    const reviews = [
        {
            name: 'Priyanka Dangayach',
            // designation: 'CEO, ABC Company',
            comment: 'At Anubhava montessori- House of children, kids are having a great learning experience with personal attentions given to everyone. Each kid is focused and developed accordingly to his capacity. The care and comfort given in school is amazing.',
            image: Female
        },
        {
            name: 'Maharsh Jain',
            // designation: 'CEO, ABC Company',
            comment: 'My son Maharsh studied in Anubhva Montessori House Of Children,he studied jus for a year n I felt a great change in him he became alert, started learning from every small thing started doing his work by himself at such an early age.Montessori is definitely the best education n AHMOC is the best Montessori with a very loving n caring faculty. The faculty is so good that your child would never forget them. Happy and lucky to be a part of this school.',
            image: Male
        },
        {
            name: 'Laila Lalani',
            // designation: 'CTO, XYZ Company',
            comment: 'For us it’s 4.5 star rating.My daughter has been going to Anubhava for more than 2 yrs .This is the best school in that area .She loves to go to Anubhava and does not want to miss a single day.Ms Varsha,Ms khudsia and other teachers are creative and dedicated.',
            image: Female
        },
        {
            name: 'Basanth Agarwal',
            // designation: 'CTO, XYZ Company',
            comment: 'My daughter Pratiti is studying in Anubhava Montessori School.. we are very happy by the way she is learning new things. Education pattern is unique and every child gets attention and independence .. what is required in pre-school. We rate as best pre-school in Hyderabad.',
            image: Male
        },
        {
            name: 'Dr Sosan Fatima',
            // designation: 'CTO, XYZ Company',
            comment: 'What a lovely concept… this school has everything a child needs in their lives. I m blessed to have some amazing teachers that nurture the children in the best way possible. I m glad that Aqsa is part of it. Shout out to Ms Khudsia and Ms Varsha (teachers) for their extraordinary dedication and commitment towards teaching the children.',
            image: Female
        },
        {
            name: 'Shweta Agarwal',
            // designation: 'CTO, XYZ Company',
            comment: 'The name Anubhava says it all. The plethora of activities, lovingness and willingness of child towards expirencing it. Ms Varsha Agarwal has created the best montessori atmosphere and her humbleness will definetly gets imbibed in our children. Love the place and lucky to be the part of the school.',
            image: Female
        },
        {
            name: 'Sai Saraswathi Pilli',
            // designation: 'CTO, XYZ Company',
            comment: 'We are delighted that we found a school like Anubhava where education is not mere input of facts but a blend of nourishing children with exceptional love, care and teaching day to day life skills with independent decision making too...',
            image: Male
        },
        {
            name: 'Sakina Fatima',
            // designation: 'CTO, XYZ Company',
            comment: 'We are glad to have our Son enrolled with Anubhava. The kind of Love and Support the children get here is exceptional. With the teaching methods they use, the child will get strong conceptually which will pave a much better understanding of subjects in future for them.',
            image: Female
        },
        // more reviews
    ];

    return (<>

        <Navbar />

        <div className="about-main">

            <div className="about-sec-1">

                <div className="about-s2-1">
                    <h1>The Anubhava Story</h1>
                    <div>
                        <p style={{ fontWeight: "600", lineHeight: "25px", marginBottom: "30px" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>Founded in 2014 in Hyderabad,</span> Anubhava Montessori School was born from a vision to create a rich, resourceful schooling environment that nurtures every child’s innate curiosity. Guided by the Montessori philosophy, we respect the child’s natural development and foster a love for learning through a prepared environment that encourages independence, self‑direction, and hands‑on exploration.</p>
                        <p style={{ fontWeight: "600", lineHeight: "25px", marginBottom: "30px" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>At Anubhava Montessori House of Children,</span> the core ethos revolves around respect for the child and a child‑led approach to learning within a carefully prepared environment. We believe every child is an innate learner, driven by interest and a desire to explore. By honouring this natural impulse, we create a space where independence, self‑discipline, and confidence flourish.</p>
                        <p style={{ fontWeight: "600", lineHeight: "25px", marginBottom: "30px" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>We offer</span>  Montessori Toddler - Play group (1.5yr – 2.5 yr),Montessori Preschool -Nursery, PP1, PP2 (2.5 yr – 6 yr), and Montessori Elementary- Primary (6 yr – 12yr) programmes - Grade 1 - Grade 6, available in half‑day and full‑day sessions.</p>
                    </div>
                    <div className="about-points">
                        <p style={{ fontWeight: "800", marginBottom: "5px", fontSize: "18px", color: "#ff8943" }}>Core Principles :</p>
                        <p><i className="fa-solid fa-chevron-right"></i> <span>Independence & Self‑Directed Learning:</span> Children choose activities that match their interests and developmental stage, fostering intrinsic motivation.</p>
                        <p><i className="fa-solid fa-chevron-right"></i> <span>Hands‑On, Self‑Correcting Materials:</span> Montessori tools enable children to discover concepts, recognize mistakes, and refine understanding independently. </p>
                        <p><i className="fa-solid fa-chevron-right"></i> <span>Holistic Development:</span> Our curriculum nurtures physical, social, emotional, and cognitive growth through practical life, sensorial, language, mathematics, and cultural activities.</p>
                    </div>


                </div>
                <div className="about-s2-2">
                    <div className="about-img-slider">
                        {storyImages.map((img, idx) => (
                            <div
                                key={idx}
                                className={`about-slide-img ${idx === imgIndex ? "active" : ""}`}
                                style={{ backgroundImage: `url(${img})` }}
                            />
                        ))}
                        <div className="about-slide-dots">
                            {storyImages.map((_, idx) => (
                                <span
                                    key={idx}
                                    className={`about-slide-dot ${idx === imgIndex ? "active" : ""}`}
                                    onClick={() => setImgIndex(idx)}
                                />
                            ))}
                        </div>
                    </div>
                </div>

            </div>
            <div style={{ marginTop: "40px" }}>
                <p style={{ fontWeight: "600", lineHeight: "25px", marginBottom: "30px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>The Prepared Environment:</span> Our classrooms are thoughtfully arranged with child‑size furniture, organized materials, encouraging exploration and concentration. Teachers act as guides, observing each child’s needs and gently scaffolding learning without interrupting the flow of discovery.</p>
                <p style={{ fontWeight: "600", lineHeight: "25px", marginBottom: "30px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>Outcomes:</span> This approach cultivates critical thinking, problem‑solving skills, and a lifelong love for learning. Children emerge with confidence, empathy, and the ability to collaborate—qualities that prepare them for future academic challenges and life beyond school. They enhance academic performance, particularly in reading and mathematics, with these benefits enduring over time.</p>
            </div>

            <div className="attributes-main" >

                <div className="am-1" >
                </div>

                {/* Toddler Areas */}
                <div className="area-section">
                    <div className="am-1 area-header">
                        <h4>Our set of <span>Activities</span></h4>
                        <h2><span>Toddler</span> Areas</h2>
                    </div>
                    <div className="attribute-grid">
                        <div className="attribute-item">
                            <div className="attribute-circle color-2"><i className="fa-solid fa-shapes"></i></div>
                            <p>Sensorial</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-3"><i className="fa-solid fa-spell-check"></i></div>
                            <p>Language</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-1"><i className="fa-solid fa-hands-bubbles"></i></div>
                            <p>Exercises of Practical Life</p>
                        </div>
                    </div>
                </div>

                {/* Montessori Areas */}
                <div className="area-section">
                    <div className="am-1 area-header">
                        <h2><span>Montessori</span> Areas</h2>
                    </div>
                    <div className="montessori-grid-row">
                        <div className="attribute-item">
                            <div className="attribute-circle color-5"><i className="fa-solid fa-cube"></i></div>
                            <p>Sensorial</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-1"><i className="fa-solid fa-calculator"></i></div>
                            <p>Number Work</p>
                        </div>
                    </div>
                    <div className="montessori-grid-row">
                        <div className="attribute-item">
                            <div className="attribute-circle color-2"><i className="fa-solid fa-language"></i></div>
                            <p>Language</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-3"><i className="fa-solid fa-globe"></i></div>
                            <p>Culture</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-4"><i className="fa-solid fa-bucket"></i></div>
                            <p>Exercises of Practical Life</p>
                        </div>
                    </div>
                </div>

                {/* Elementary Areas */}
                <div className="area-section">
                    <div className="am-1 area-header">
                        <h2><span>Elementary</span> Areas</h2>
                    </div>
                    <div className="attribute-grid-large">
                        <div className="attribute-item">
                            <div className="attribute-circle color-6"><i className="fa-solid fa-mountain-sun"></i></div>
                            <p>Geography</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-4"><i className="fa-solid fa-landmark"></i></div>
                            <p>History</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-1"><i className="fa-solid fa-microscope"></i></div>
                            <p>Biology</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-2"><i className="fa-solid fa-draw-polygon"></i></div>
                            <p>Geometry</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-3"><i className="fa-solid fa-plus-minus"></i></div>
                            <p>Maths</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-4"><i className="fa-solid fa-palette"></i></div>
                            <p>Art & Music</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-5"><i className="fa-solid fa-flask"></i></div>
                            <p>Physics & Chemistry</p>
                        </div>
                        <div className="attribute-item">
                            <div className="attribute-circle color-6"><i className="fa-solid fa-book-open"></i></div>
                            <p>Languages (English/Hindi/Telugu)</p>
                        </div>
                    </div>
                </div>


            </div>

            <div className="attributes-main" style={{ marginTop: "80px" }} >

                <div className="am-1" >
                    <h4>A family of trained <span>Montessori Educators</span></h4>
                    <h2>Our <span>Guides</span> who inspire</h2>
                </div>

                {/* Upper featured section — 2 cards */}
                <div className="guides-featured-row">
                    <div className="about-cards about-card-featured">
                        <img alt={guides[0].name} src={guides[0].image} />
                        <h4>{guides[0].name}</h4>
                        <p>{guides[0].role}</p>
                        <button className="guide-read-more-btn" onClick={() => setSelectedMember(guides[0])}>Read More</button>
                    </div>
                    <div className="about-cards about-card-featured">
                        <img alt={guides[1].name} src={guides[1].image} />
                        <h4>{guides[1].name}</h4>
                        <p>{guides[1].role}</p>
                        <button className="guide-read-more-btn" onClick={() => setSelectedMember(guides[1])}>Read More</button>
                    </div>
                </div>

                {/* Bottom slider — remaining team members */}
                <div className="guides-slider-wrapper">
                    <Slider
                        dots={false}
                        infinite={true}
                        speed={600}
                        slidesToShow={slidesToShow}
                        slidesToScroll={1}
                        autoplay={true}
                        autoplaySpeed={3000}
                        cssEase="ease-in-out"
                        arrows={true}
                    >
                        {[
                            guides[2],
                            guides[3],
                            guides[4],
                            guides[5],
                            guides[2],
                            guides[3]
                        ].map((member, i) => (
                            <div key={i} className="guides-slide-item">
                                <div className="about-cards about-card-slide">
                                    <img alt={member.name} src={member.image} />
                                    <h4>{member.name}</h4>
                                    <p>{member.role}</p>
                                    <button className="guide-read-more-btn" onClick={() => setSelectedMember(member)}>Read More</button>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>

                {/* Team Guide Detail Modal Popup */}
                {selectedMember && (
                    <div className="guide-modal-overlay" onClick={() => setSelectedMember(null)}>
                        <div className="guide-modal-content" onClick={(e) => e.stopPropagation()}>
                            <div className="guide-modal-header">
                                <div className="guide-modal-header-text">
                                    <h2>Profile</h2>
                                    <p>{selectedMember.role}</p>
                                </div>
                                <button className="guide-modal-close-x" onClick={() => setSelectedMember(null)}>&times;</button>
                            </div>
                            
                            <div className="guide-modal-body">
                                <div className="guide-modal-left">
                                    <div className="guide-modal-img-wrapper">
                                        <img src={selectedMember.image} alt={selectedMember.name} />
                                    </div>
                                    {selectedMember.email && (
                                        <a href={`mailto:${selectedMember.email}`} className="guide-modal-email-btn">
                                            <i className="fa-solid fa-envelope"></i> Email
                                        </a>
                                    )}
                                </div>
                                
                                <div className="guide-modal-right">
                                    <h1 className="guide-modal-name">{selectedMember.name}</h1>
                                    <p className="guide-modal-quote">"{selectedMember.quote}"</p>
                                    
                                    <div className="guide-modal-details-grid">
                                        {selectedMember.education && (
                                            <div className="guide-detail-block">
                                                <h3>Educational Origin</h3>
                                                <p>{selectedMember.education}</p>
                                            </div>
                                        )}
                                        {selectedMember.journey && (
                                            <div className="guide-detail-block">
                                                <h3>Pedagogical Journey</h3>
                                                <p>{selectedMember.journey}</p>
                                            </div>
                                        )}
                                        {selectedMember.expertise && (
                                            <div className="guide-detail-block">
                                                <h3>Expertise</h3>
                                                <p>{selectedMember.expertise}</p>
                                            </div>
                                        )}
                                        {selectedMember.philosophy && (
                                            <div className="guide-detail-block">
                                                <h3>Guiding Philosophy</h3>
                                                <p>{selectedMember.philosophy}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            
                            <div className="guide-modal-footer">
                                <button className="guide-modal-close-btn" onClick={() => setSelectedMember(null)}>Close</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="about-others">

                <div className="am-1" >
                    <h4>Real <span>stories</span> of joy, growth & learning</h4>
                    <h2>Here's what <span style={{ color: "#fff" }}>Parents</span> say</h2>
                </div>

                <div className="testimonialDiv" >
                    <Slider
                        dots={true}
                        infinite={true}
                        speed={500}
                        slidesToShow={1}
                        slidesToScroll={1}
                        autoplay={true}
                        autoplaySpeed={5000}
                        cssEase={'linear'}
                        arrows={false}
                    >
                        {reviews.map((review, index) => (
                            <div key={index}>
                                <div className="client-image">
                                    <img src={review.image} alt={""} />
                                </div>
                                <div className="client-name"><p style={{ textAlign: "center" }}>{review.name}</p></div>
                                <div className="client-designation">{review.designation}</div>
                                <div className="client-comment">{review.comment}</div>
                            </div>
                        ))}
                    </Slider>
                </div>

            </div>

        </div>

        <FAQ />

        <Footer />

    </>)

}

export default About;